import React from "react";
import "./css/App.css";
//import "./css2/bootstrap.css";
import "./css2/responsive.css";
import "./css2/ui.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import ProductList from "./components/ProductList";
import Sponsors from "./components/Sponsors";
import Strategy from "./components/Strategy";
import Infos from "./components/Infos";
import Footer from "./components/Footer";
import Navbar2 from "./components/Navbar2";

function App() {
  return (
    <div>
      <Navbar />
      <Banner></Banner>
      <ProductList />
      <ProductList />
      <Sponsors></Sponsors>
      <Strategy></Strategy>
      <Infos></Infos>
      <Footer />
    </div>
  );
}

export default App;
